export var ChainShakeContent;
(function (ChainShakeContent) {
    ChainShakeContent["ShakesInTheWater"] = "Shakles in the water";
    ChainShakeContent["ShakesInThePile"] = "Shakles in the pipe";
    ChainShakeContent["ShakesOnDeck"] = "Shakles on Deck";
})(ChainShakeContent || (ChainShakeContent = {}));
//# sourceMappingURL=ChainShakeContent.js.map